import React, { useCallback } from 'react';
import { IconCloseSvg } from 'apps/sigma2-ui/src/components/svg/IconClose';
import { Dialog } from '@headlessui/react';
import cn from 'classnames';

export interface LightModalProps {
  title: React.ReactNode;
  showModal: boolean;
  onClose: () => void;
  children: React.ReactNode;
  actions?: React.ReactNode;
  width?: string;
  showHeaderDivider?: boolean;
  contentClassName?: string;
  showCloseButton?: boolean;
  panelClassName?: string;
}

export const LightModal = (props: LightModalProps) => {
  const {
    title,
    showModal,
    onClose,
    children,
    actions,
    width = 'w-1/2',
    showHeaderDivider = true,
    contentClassName,
    showCloseButton = true,
    panelClassName,
  } = props;

  const handleClose = useCallback(() => {
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  return (
    <Dialog
      open={showModal}
      as="div"
      className="relative z-overlay-cover"
      onClose={handleClose}
    >
      <div className="fixed inset-0 bg-black bg-opacity-25" />

      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center">
          <Dialog.Panel
            className={cn(
              'flex flex-col transform rounded-2xl bg-white p-6 text-left align-middle shadow-12px transition-all',
              width,
              panelClassName,
            )}
          >
            <div className="flex min-h-0 flex-col">
              <div
                className={cn('-mx-6', {
                  'pb-4': showHeaderDivider,
                  'border-b border-gray-200': showHeaderDivider,
                })}
              >
                <div className="flex justify-between content-center mx-6 ">
                  {title}
                  {showCloseButton ? (
                    <button onClick={handleClose}>
                      <IconCloseSvg
                        svg={{ className: 'w-6 h-6 text-gray-600' }}
                      />
                    </button>
                  ) : null}
                </div>
              </div>
              <div className={cn('min-h-0 py-4', contentClassName)}>
                {children}
              </div>
              {actions && <div className="flex justify-end">{actions}</div>}
            </div>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
};
